module.exports = __webpack_public_path__ + "img/type.55e46d8e.png";